import React from 'react';
import ReactDOM from 'react-dom';
import './styles/pure.css';
import './styles/grids-responsive-min.css';
import './styles/index.css';
import App from './classes/app/App';
import registerServiceWorker from './registerServiceWorker';
import {
  BrowserRouter as Router
} from 'react-router-dom';

import moment from 'moment';
import 'moment/locale/pt-br';

moment.locale('pt-BR');

var path;//variárel referente ao caminho do projeto

switch(process.env.REACT_APP_ENV) {
  case "1":
    path = "./";
    break;
  case "2":
    path = "";
    //'mudar me package.json o nó homepage para o valor correto: http://foco90.com.br/sandbox/'
    break;
  case "3":
    path = "/foco90/v4/Foco90/sistema/build/";
    //'mudar me package.json o nó homepage para o valor do servidor: foco90/sistema/sistema/sistema/build/'
    break;
}

//type npm run local
//homepage = "/foco90/v4/Foco90/sistema-cliente/build/";
//path = "/foco90/v4/Foco90/sistema-cliente/build/";

window.localStorage.clear();

ReactDOM.render(<Router basename={path}><App /></Router>, document.getElementById('root'));
//registerServiceWorker();



//type npm run build
//homepage = http://foco90.com.br/sandbox/
//path = /sandbox



// WEBPACK FOOTER //
// ./src/index.js